import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { generateErrorMessages } from '@app/core/services/validation/validation-service.error-messages';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  constructor() {}

  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const errorMessages = generateErrorMessages(validatorValue);

    return errorMessages[validatorName];
  }

  static password(control: FormControl) {
    const controlValue = control.value;
    if (controlValue) {
      if (
        !controlValue.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,99})/
        )
      ) {
        return { invalidPassword: true };
      }
    }

    return null;
  }

  static passwordOld(control: FormControl) {
    const controlValue = control.value;

    if (controlValue) {
      if (!controlValue.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&amp;*]{5,100}$/)) {
        return { invalidPasswordOld: true };
      }
    }

    return null;
  }

  static onlyAlphaCharacters(control: FormControl) {
    if (control.value && control.value.match(/^[a-zA-Z ]*$/)) {
      return null;
    } else {
      return { onlyAlphaCharacters: true };
    }
  }

  static cpf(control: FormControl) {
    if (control.value.match(/^\d{11}$/)) {
      return null;
    } else {
      return {
        invalidCPF: true,
      };
    }
  }

  static voucher(control: FormControl) {
    if (control.value.match(/^\d{4}$/)) {
      return null;
    } else {
      return {
        invalidVoucher: true,
      };
    }
  }

  static match(
    controlName: string,
    matchingControlName: string
  ): ValidationErrors | null {
    return (formGroup: FormGroup) => {
      const control = controlName
        .split('.')
        .reduce((object, index) => object.controls[index], formGroup);

      const matchingControl = matchingControlName
        .split('.')
        .reduce((object, index) => object.controls[index], formGroup);

      if (matchingControl.errors && !matchingControl.errors.invalidMatch) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ invalidMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  static noFutureDate(control: FormControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const date = moment(value, 'DD/MM/YYYY');

    if (!date.isValid()) {
      return {
        dateInvalid: true,
      };
    }

    const today = moment().startOf('day');

    return date.isAfter(today) ? { noFutureDate: true } : null;
  }

  static ageNotLessThan(minAge: number): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const date = moment(value, 'DD/MM/YYYY');

      if (!date.isValid()) {
        return {
          dateInvalid: true,
        };
      }

      const today = moment().startOf('day');

      return today.diff(date, 'years') < minAge ? { ageNotLessThan: { minAge } } : null;
    };
  }
}
